import React, { type PropsWithChildren } from 'react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { CommentAuthor } from '@confluence/inline-comments-common/entry-points/CommentAuthor.ts';
import { WithCurvedBranchingStyle } from '@confluence/inline-comments-common/entry-points/components.ts';

const styles = cssMap({
	editorContainer: {
		width: '100%',
		paddingLeft: token('space.050'),
	},
	commentAuthorContainer: {
		paddingLeft: token('space.050'),
		paddingTop: token('space.100'),
	},
});

const customCurvedBranchingStyles = {
	height: token('space.300'),
	left: token('space.negative.200'),
};

export const RepliesFooterEditor = ({ children: replyEditor }: PropsWithChildren<{}>) => {
	const { userId } = useSessionData();

	return (
		<>
			<WithCurvedBranchingStyle showDefaultStyles customStyles={customCurvedBranchingStyles}>
				<Box xcss={styles.commentAuthorContainer}>
					<CommentAuthor size="small" commentMode="create" userId={userId} />
				</Box>
			</WithCurvedBranchingStyle>
			<Box testId="reply-editor-container" xcss={styles.editorContainer}>
				{replyEditor}
			</Box>
		</>
	);
};
